var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.b(), { 'is-collapse': _vm.collapse }]},_vm._l((_vm.menus),function(menu){return _c('LeftMenuComponent',_vm._g({key:menu.name,attrs:{"item":menu},scopedSlots:_vm._u([_vm._l((_vm.itemSlots),function(key){return {key:key,fn:function(ref){
var item = ref.item;
return [_vm._t(key,null,{"item":item})]}}})],null,true)},_vm.$listeners))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }